import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext, useNavigate } from "react-router-dom";

const useBlocker = (blocker, when = true, isDistrictChanged) => {
  const navigator = useContext(UNSAFE_NavigationContext).navigator;
  const navigate = useNavigate();
  useEffect(() => {
    if (!when) return;

    if (isDistrictChanged) {
      navigate("/", { replace: true });
      return;
    }

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        }
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when, isDistrictChanged, navigate]);
};

export default useBlocker;
